import { Injectable } from '@angular/core';
import {
  Action,
  State,
  Selector,
  StateContext,
} from '@ngxs/store';
import { patch } from '@ngxs/store/operators';
import { BalloonsStateModel } from './balloons-state.models';
import { BalloonsStateActions } from './balloons-state.actions';
import { DbrBalloonEntity } from '@balloon-race-fullstack-monorepo/dbr-rest-api';

const STATE_NAME = 'BalloonsState';

@State<BalloonsStateModel>({
  name: STATE_NAME,
  defaults: {
    balloons: [],
    activeBalloonCode: null,
  },
})
@Injectable()
export class BalloonsState {
  @Selector()
  static balloons(state: BalloonsStateModel): DbrBalloonEntity[] | null {
    return state.balloons;
  }

  @Selector()
  static activeBalloon(state: BalloonsStateModel): DbrBalloonEntity | null {
    return (state.balloons.find((item) => item.code === state.activeBalloonCode)) || null;
  }

  @Selector()
  static activeBalloonCode(state: BalloonsStateModel): string | null {
    return state.activeBalloonCode;
  }

  @Action(BalloonsStateActions.SetBalloons)
  setBalloons(ctx: StateContext<BalloonsStateModel>, action: BalloonsStateActions.SetBalloons) {
    ctx.setState(patch<BalloonsStateModel>({
      balloons: action.balloons,
    }));
  }

  @Action(BalloonsStateActions.SetActiveBalloonCode)
  setActiveBalloonCode(ctx: StateContext<BalloonsStateModel>, action: BalloonsStateActions.SetActiveBalloonCode) {
    ctx.setState(patch<BalloonsStateModel>({
      activeBalloonCode: action.balloonCode,
    }));
  }
}

